import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BusinessModelOption {
    sub_seller_business_type_id: string;
    business_type: string;
}

interface GDSOption {
    company_name: string;
    seller_aggregator_id: string;
}

interface LanguageState<T> {
    en: T[];
    fr: T[];
}

interface SubSellerSignUpState {
    businessModelOptions: LanguageState<BusinessModelOption>;
    GDSOptions: LanguageState<GDSOption>;
    loading: boolean;
    error: string | null;
    formSubmitted: boolean;
}

const initialState: SubSellerSignUpState = {
    businessModelOptions: { en: [], fr: [] },
    GDSOptions: { en: [], fr: [] },
    loading: false,
    error: null,
    formSubmitted: false,
};

const subSellerSignUpSlice = createSlice({
    name: 'subSellerSignUp',
    initialState,
    reducers: {
        fetchFormDataStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchFormDataSuccess(state, action: PayloadAction<{ businessModelResponse: any, gdsResponse: any }>) {
            state.loading = false;
            state.businessModelOptions = {
                en: action.payload.businessModelResponse.data.map((item: any) => ({
                    sub_seller_business_type_id: item.sub_seller_business_type_id,
                    business_type: item.business_type_en,
                })),
                fr: action.payload.businessModelResponse.data.map((item: any) => ({
                    sub_seller_business_type_id: item.sub_seller_business_type_id,
                    business_type: item.business_type_fr,
                })),
            };
            state.GDSOptions = {
                en: action.payload.gdsResponse.data,
                fr: action.payload.gdsResponse.data
            };
        },
        fetchFormDataFailure(state, action: PayloadAction<string>) {
            state.loading = false;
            state.error = action.payload;
        },
        submitFormRequest(state, action: PayloadAction<any>) { },
        submitFormSuccess(state) {
            state.formSubmitted = true;
            state.error = null;
        },
        submitFormFailure(state, action: PayloadAction<string>) {
            state.error = action.payload;
        }

    },
});

export const { fetchFormDataStart,
    fetchFormDataSuccess,
    fetchFormDataFailure,
    submitFormRequest,
    submitFormSuccess,
    submitFormFailure
} = subSellerSignUpSlice.actions;
export default subSellerSignUpSlice.reducer;